import { useSelector } from "react-redux";
import Accounting from "accounting";

export const CurrencyFormatter = ({
    amount,
    currencySymbol,
    currencyFormat,
    symbolClass = "",
    valueClass = "",
    symbolId,
    valueId,
    id,
    className,
    as = "jsx" }) => {

    const safeAmount = isNaN(Number(amount)) ? 0 : Number(amount);

    const formattedAmount = Accounting.formatMoney(safeAmount, {
        symbol: currencySymbol,
        format: currencyFormat,
        thousand: ",",
        decimal: ".",
        precision: 2,
    });

    const [symbol, value] = formattedAmount.split(" ");

    if (as === "string") {
        return formattedAmount;
    }


    return (
        <div className={className} id={id}>
            <span id={symbolId} className={symbolClass}>{symbol}&nbsp;</span>
            <span id={valueId} className={valueClass}>{value}</span>
        </div>
    );
};

export const FormatCurrency = ({
    amount,
    currencySymbol,
    currencyFormat,
    className = "",
    id,
    as = "jsx"
}) => {
    const safeAmount = isNaN(Number(amount)) ? 0 : Number(amount);

    const formattedAmount = Accounting.formatMoney(safeAmount, {
        symbol: currencySymbol,
        format: currencyFormat,
        thousand: ",",
        decimal: ".",
        precision: 2,
    });

    if (as === "string") {
        return formattedAmount;
    }

    return (
        <span id={id} className={className}>
            {formattedAmount}
        </span>
    );
};


export const useCurrencyConstants = () => {
    const defMembership = useSelector((state) => state.defMembership.defMembership);

    return {
        currencySymbol: defMembership?.business.currency || "",
        currencyFormat: "%s %v"
    };
};